<template>
  <div class="vx-row">
    <!-- Title -->
    <p class="m-1 vs-col w-full">
      <b>{{ title }}</b>
    <p>
    <div class="vs-col w-full">
      <!-- Numbers/Rating buttons -->
      <vs-button
        v-for="i in ratingsList" :key="i"
        class="m-1"
        :color="rating == i? selectColor : defaultColor"
        @click="updateValue(i)">
          {{ i }}
      </vs-button>
      <!-- Not Applicable button -->
      <vs-button
        v-if="addNotApplicable"
        class="m-1"
        :color="rating == 0? selectColor : defaultColor"
        @click="updateValue(0)">
          Not Applicable
      </vs-button>
    </div>
    <!-- Text for how can we improve -->
    <div v-if="showMessage" class="vs-col w-full m-5">
      <p> <b>How can we improve ? </b> </p>
      <div>
        <div></div>
        <vs-input
          class="vs-col w-8/12"
          v-model="imporovisationMessage"
          @input="messageChanged"
        />
      </div>
    </div>

  </div>
</template>

<script>
export default {

  props:{
    addNotApplicable: {
      type: Boolean,
      default: false
    },
    ratingMin: {
      type: Number,
      default: 1
    },
    ratingMax: {
      type: Number,
      default: 10
    },
    title: {
      type: String,
      default: 'Title'
    }
  },

  data () {
    return  {
      min_rating: this.ratingMin,
      max_rating: this.ratingMax,
      allowaddNotApplicable: this.addNotApplicable,
      rating: this.min_rating,
      defaultColor: '#bbb',
      selectColor: '#75A68C',
      imporovisationMessage: ''
    }
  },
  computed: {
    ratingsList () {
      const arr = []
      for (let i = this.min_rating; i <= this.max_rating; i++) {
        arr.push(i)
      }
      return arr
    },
    showMessage () {
      if (this.rating && this.rating < this.max_rating) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    updateValue (value) {
      this.rating = value
      this.$emit('rating', value)
      // if the rating becomes 0 or max, change message to empty
      if (value == 0 || value == this.max_rating) {
        this.imporovisationMessage = ''
        this.$emit('message', '')
      }
    },
    messageChanged (value) {
      this.$emit('message', value)
    }
  }

}
</script>

<style>

  .left{
    text-align: left;
  }

</style>